import { useEffect } from "react";
import { toast } from "react-toastify";

import { useLocale } from "src/providers/LocaleProvider";
import { emitter } from "src/shared/emitter";
import { errorService, infoService } from "src/service/services";
import { useLocaleByLabel } from "src/hooks/useLocaleByLabel";
import { ILocaleItem } from "src/store/models";
import { loggerService } from "src/entities/logger";

import { UnhandledExceptionNotification } from "../UnhandledExceptionNotification";

const EventEmitter = () => {
    const {
        common: {
            auth: {
                errors: { unAuthorizedErrorMessage },
            },
            errors: { sectionAccessBlocked },
        },
    } = useLocale();
    const { getLocaleByLabel } = useLocaleByLabel();

    useEffect(() => {
        emitter.on("auth:unauthorizedUser", () => {
            errorService.sendError(
                unAuthorizedErrorMessage(
                    "Sorry, you are not authorized to access this page. Please log in to continue."
                )
            );
        });
        emitter.on("locale:error", (locale: ILocaleItem) => {
            errorService.sendError(
                getLocaleByLabel(locale.label, locale.defaultValue)
            );
        });

        emitter.on("locale:info", (locale: ILocaleItem) => {
            infoService.sendInfo(
                getLocaleByLabel(locale.label, locale.defaultValue)
            );
        });

        emitter.on("unhandledException", () => {
            toast(<UnhandledExceptionNotification />);
        });

        emitter.on("sectionAccessBlocked", () => {
            errorService.sendError(
                sectionAccessBlocked(
                    "Access to the requested section has been temporarily blocked for security reasons."
                )
            );
        });
        emitter.on("logger:debug", async (name: string, data: any) => {
            try {
                await loggerService.debug(name, data);
            } catch (e) {}
        });

        return () => {
            emitter.removeAllListeners("locale:error");
            emitter.removeAllListeners("locale:info");
            emitter.removeAllListeners("auth:unauthorizedUser");
            emitter.removeAllListeners("unhandledException");
            emitter.removeAllListeners("sectionAccessBlocked");
            emitter.removeAllListeners("logger:debug");
        };
    }, [getLocaleByLabel]);
    return null;
};

export default EventEmitter;
